import React, {useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import SurveysSummaryBrowser from "./SurveysSummaryBrowser";
import SurveysSummaryEditor from "./SurveysSummaryEditor";

const SurveysSummarySubPage = ({isAddSubMode, surveyData}) => {

    const [summaryData, setSummaryData] = useState(null);
    const [refsData, setRefsData] = useState({});

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {!isAddSubMode && <div className={cl.browserArea} style={undefined}>
                    <SurveysSummaryBrowser
                        setSummaryData={setSummaryData}
                        refsData={refsData}
                        setRefsData={setRefsData}
                    />
                </div>}
                <div className={cl.editorArea}>
                    <SurveysSummaryEditor
                        surveyData={surveyData}
                        summaryData={summaryData}
                    />
                </div>
            </div>
        </div>
    );
};

export default SurveysSummarySubPage;